import { Link } from 'react-router-dom';
import usePageMeta from '../lib/usePageMeta';
import PageHero from '../components/PageHero';
import Icon from '../components/Icon';
import { SectionHead, ServiceGrid, ProcessTimeline } from '../components/Blocks';
import { EXTRA_SERVICES, ENGAGEMENT } from '../data';

export default function Services() {
  usePageMeta('Services', 'Web development, mobile apps, UI/UX design, branding, 2D/3D animation, e-commerce, SEO, social media, cloud, AI and QA — all services from Origo Private Limited.');

  return (
    <>
      <PageHero
        eyebrow="Our services"
        title="Everything you need to build, launch and grow online"
        description="Twelve core services delivered by one coordinated team — so strategy, design, development and marketing work together instead of in silos."
        crumbs={[{ label: 'Services' }]}
      />

      <section className="section bg-brand-soft">
        <div className="container-x">
          <ServiceGrid />
          <div className="mt-14 text-center" data-anim="up">
            <p className="text-sm font-semibold uppercase tracking-widest text-slate-500">Also available</p>
            <div className="mt-4 flex flex-wrap justify-center gap-3">
              {EXTRA_SERVICES.map((e) => <span key={e} className="rounded-full border border-brand/20 bg-white px-4 py-2 text-sm font-medium text-brand">{e}</span>)}
            </div>
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container-x">
          <SectionHead eyebrow="Engagement models" title="Flexible ways to work with us" text="Choose the model that fits your project and budget — and change it as your needs evolve." />
          <div className="mt-14 grid gap-6 lg:grid-cols-3" data-anim="up" data-stagger>
            {ENGAGEMENT.map((m) => (
              <div key={m.title} className={`lift rounded-3xl p-8 ${m.highlight ? 'bg-gradient-to-br from-brand to-ink text-white shadow-2xl' : 'border border-brand/10 bg-brand-soft/60'}`}>
                <h3 className="text-2xl font-bold">{m.title}</h3>
                <p className={`mt-3 ${m.highlight ? 'text-white/75' : 'text-slate-600'}`}>{m.desc}</p>
                <ul className="mt-6 space-y-3">
                  {m.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm"><Icon name="check" className={`h-4 w-4 ${m.highlight ? 'text-brand-lime' : 'text-brand'}`} strokeWidth={2.6} />{p}</li>
                  ))}
                </ul>
                <Link to="/contact" className={`mt-8 ${m.highlight ? 'btn-primary' : 'btn-outline'}`}>Discuss this model</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-brand-soft">
        <div className="container-x grid gap-14 lg:grid-cols-[.85fr_1.15fr]">
          <div className="lg:sticky lg:top-32 lg:self-start" data-anim="left">
            <span className="eyebrow">Our approach</span>
            <h2 className="h2 mt-5 text-ink">The same <span className="text-accent">proven</span> process for every <span className="text-outline">service</span></h2>
            <p className="mt-5 text-lg text-slate-600">Whatever you are building, you get clear phases, regular demos and a team accountable for results.</p>
            <Link to="/process" className="btn-green mt-8">Learn about our process <Icon name="arrow" className="h-4 w-4" /></Link>
          </div>
          <ProcessTimeline />
        </div>
      </section>
    </>
  );
}
